// A mesma chave de participante e formulario sempre exibir na mesma ordem
const getQuestionRank = (value) => {
  let hash = 2166136261;

  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
  }

  hash = Math.imul(hash ^ (hash >>> 16), 0x85ebca6b);
  hash = Math.imul(hash ^ (hash >>> 13), 0xc2b2ae35);
  return (hash ^ (hash >>> 16)) >>> 0;
};

export const randomizeFormularioGlobalSections = (
  sections,
  randomizationKey
) => {
  const questions = sections
    .flatMap((section) => section.perguntas)
    .map((question) => ({
      question,
      key: question._formularioGlobalPreviewKey,
      rank: getQuestionRank(
        JSON.stringify([randomizationKey, question._formularioGlobalPreviewKey])
      ),
    }))
    .sort((a, b) => {
      if (a.rank !== b.rank) return a.rank - b.rank;
      if (a.key === b.key) return 0;
      return a.key < b.key ? -1 : 1;
    })
    .map(({ question }) => question);

  if (questions.length === 0) return [];

  return [
    {
      _formularioGlobalPreviewKey: 'randomized-questions',
      perguntas: questions,
    },
  ];
};
